module.exports = __webpack_public_path__ + "img/专利授权数图标.8d5a2016.png";